import React, { useState } from 'react';

// CONTEXT
import { useTheme } from 'context/ThemeContext';
import { useSeasonTheme } from 'context/SeasonThemeContext';

// ICONS
import { Sun, Moon, UserRoundCog, SquarePen } from 'lucide-react';

// COMPONENTS
import TooltipComponent from './tooltipComponent';

const Menu = ({ onModifyInterface, isAdmin, hasNewTiles = false, hasPendingProposals = false }) => {
    const { theme, changeTheme } = useTheme();
    const { seasonTheme } = useSeasonTheme();
    const [isAnimating, setIsAnimating] = useState(false);
    const [animationDirection, setAnimationDirection] = useState(null);

    const handleToggleDarkMode = () => {
        setIsAnimating(true);
        setAnimationDirection(
            theme === 'light' ? 'dark' : 'light'
        );

        setTimeout(() => {
            changeTheme(
                theme === 'light' ? 'dark' : 'light'
            );
            setIsAnimating(false);
            setAnimationDirection(null);
        }, 500);
    };

    const handleGoAdmin = () => {
        window.location.href = '/admin/dashboard/analytics';
    };

    const menuItems = [
        { id: 'edit', text: 'Modifier l\'interface', icon: SquarePen, onClick: onModifyInterface },
        isAdmin && { id: 'admin', text: 'Administration', icon: UserRoundCog, onClick: handleGoAdmin },
    ].filter(Boolean);

    return (
        <div className='flex items-center space-x-1 sm:space-x-2 relative overflow-visible'>
            {/* Bouton de changement de thème */}
            {seasonTheme !== 'halloween' && (
                <TooltipComponent title={theme === 'light' ? 'Mode Jour' : 'Mode Nuit'}>
                    <button
                        className={`relative p-2 rounded-md text-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 dark:text-gray-300 transition-colors group focus:outline-none`}
                        onClick={handleToggleDarkMode}
                        aria-label={theme === 'light' ? 'Passer en mode sombre' : 'Passer en mode clair'}
                    >
                        <div className="relative size-5">
                            <Moon
                                alt="Mode Jour"
                                className={`absolute size-5 text-bleu dark:text-blanc
                                    ${((theme === 'light' && !isAnimating) || (isAnimating && animationDirection === 'light')) ? 'opacity-100' : 'opacity-0'}
                                    ${isAnimating ? (animationDirection === 'dark' ? 'animate-sun-set' : animationDirection === 'light' ? 'animate-sun-rise' : '') : ''}
                                `}
                            />
                            <Sun
                                alt="Mode Nuit"
                                className={`absolute size-5 text-bleu dark:text-blanc
                                    ${((theme === 'dark' && !isAnimating) || (isAnimating && animationDirection === 'dark')) ? 'opacity-100' : 'opacity-0'}
                                    ${isAnimating ? (animationDirection === 'dark' ? 'animate-moon-rise' : animationDirection === 'light' ? 'animate-moon-set' : '') : ''}
                                `}
                            />
                        </div>
                    </button>
                </TooltipComponent>
            )}

            {/* Boutons du menu */}
            {menuItems.map((item) => {
                const IconComponent = item.icon;

                return (
                    <div key={item.id} className="relative flex flex-col items-center">
                        <TooltipComponent 
                            title={item.id === 'edit' && hasNewTiles ? `${item.text} - Nouvelles tuiles disponibles !` : item.text}
                        >
                            <button
                                className={`relative p-2 rounded-md text-bleu dark:text-blanc hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors group focus:outline-none`}
                                onClick={item.onClick}
                                aria-label={item.text}
                            >
                                {IconComponent && (
                                    <IconComponent size={20} />
                                )}
                                
                                {/* Pastille de notification pour Admin */}
                                {item.id === 'admin' && hasPendingProposals && (
                                    <div className="absolute -top-1 -right-1 size-3 bg-red-500 rounded-full animate-pulse">
                                        <div className="absolute inset-0 size-3 bg-red-500 rounded-full animate-ping opacity-75"></div>
                                    </div>
                                )}
                                 {/* Pastille de notification pour Edit lorsqu'il y a de nouvelles tuiles */}
                                 {item.id === 'edit' && hasNewTiles && (
                                     <div className="absolute -top-1 -right-1 size-3 bg-red-500 rounded-full animate-pulse">
                                         <div className="absolute inset-0 size-3 bg-red-500 rounded-full animate-ping opacity-75"></div>
                                     </div>
                                 )}
                            </button>
                        </TooltipComponent>
                        
                    </div>
                );
            })}
        </div>
    );
};

export default Menu;